module.exports = __webpack_public_path__ + "static/media/SJE089.3b41153c.png";